import styled from 'styled-components';
import ReactMarkdown from 'react-markdown';

export const OSSAgreementContainer = styled.div`
  height: 100%;
  display: flex;
  flex-grow: 1;
  overflow: hidden;
`;

export const Content = styled.div`
  padding: 6px 24px 52px 24px;
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (max-width: 1440px) {
    padding: 6px 6px 52px 6px;
  }

  @media (max-width: 768px) {
    width: 100% !important;
    height: 100% !important;
    padding: 0 !important;
  }
`;

export const OSSContent = styled(ReactMarkdown)`
  overflow-y: scroll;
  flex-grow: 1;
  overflow-wrap: break-word;
  border: 1px solid #ddd;
  padding: 10px;
  text-align: justify;
`;